import SwitchButton, { SwitchLabelLocation } from './SwitchButton';
export default SwitchButton;
export { SwitchLabelLocation };
